import axios from './axios';

export const resetPassword = async (token, email,password) => {
  await axios.put(`accounts/reset-password?token=${token}&email=${email}`, {password});
};

export const verify = async (email) => {
  await axios.put(`accounts/reset-password/verify`, { email: email });
};
